// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B5__","rootMobile":"styles_rootMobile__1BHJM"};